import { render, staticRenderFns } from "./ExpertLeaveRecord.vue?vue&type=template&id=a4e126bc&scoped=true"
import script from "./ExpertLeaveRecord.vue?vue&type=script&lang=js"
export * from "./ExpertLeaveRecord.vue?vue&type=script&lang=js"
import style0 from "./ExpertLeaveRecord.vue?vue&type=style&index=0&id=a4e126bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e126bc",
  null
  
)

export default component.exports